import './registerServiceWorker'
import '@styles/index.scss'
import app from '@core/app'
import './assets/tailwind.css'

app.mount('#app')
